import { render } from "./SuperLink.vue?vue&type=template&id=3da4fbcd&scoped=true"
import script from "./SuperLink.vue?vue&type=script&lang=js"
export * from "./SuperLink.vue?vue&type=script&lang=js"

import "./SuperLink.vue?vue&type=style&index=0&id=3da4fbcd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3da4fbcd"]])

export default __exports__